<template>
  <Dialog v-model:visible="showModal" class="lg:w-1/3 md:w-2/3 w-2/3 bg-white shadow rounded-xl" :modal="true">
    <template #header>
      <div class="w-full text-center text-gray-900 font-semibold">{{lang['components']['Dialog']['PaymentInfoDialog']['payment_info_title_text']}}</div>
    </template>
    <ul class="flex-1 space-y-6 mx-8 pl-6">
        <li v-if="invoicesData.card_no != ''">
          <p class="text-gray-700 font-medium">{{lang['components']['Dialog']['PaymentInfoDialog']['payment_info_bind_card_credit_text']}}</p>
          <p class="text-gray-500 text-sm flex flex-wrap justify-start">
            <span>{{ invoicesData.card_no }}</span>
            <!-- <a href="javascript:void(0);" class="text-blue-500 underline ml-4 text-sm" @click="payPlan()">{{lang['components']['Dialog']['PaymentInfoDialog']['payment_info_bind_card_credit_update_text']}}</a> -->
          </p>
        </li>
        <li class="space-y-4">
          <p class="text-gray-700 font-medium">
            <span>{{lang['components']['Dialog']['PaymentInfoDialog']['payment_info_invoice_info_text']}}</span>
            <a
              href="javascript:void(0);"
              class="text-blue-500 underline ml-4 font-normal text-sm"
              @click="isEdit=true"
            >{{lang['components']['Dialog']['PaymentInfoDialog']['payment_info_invoice_info_update_text']}}</a>
          </p>
          <div class="mb-4">
            <label class="block text-sm text-gray-700" for="firstName">
              {{lang['components']['Dialog']['PaymentInfoDialog']['payment_info_invoice_info_identifier_text']}}
            </label>
            <input
              class="w-full px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
              type="text"
              v-model="invoicesData.identifier"
              v-if="isEdit"
            />
            <span v-else class="text-gray-500">{{ invoicesData.identifier }}</span>
          </div>
          <div class="mb-4">
            <label class="block text-sm text-gray-700" for="firstName">
              {{lang['components']['Dialog']['PaymentInfoDialog']['payment_info_invoice_info_name_text']}}
              <span class="font-bold">{{lang['components']['Dialog']['PaymentInfoDialog']['payment_info_invoice_info_name_text_info']}}</span>
            </label>
            <input
              class="w-full px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
              type="text"
              v-model="invoicesData.name"
              v-if="isEdit"
            />
            <span v-else class="text-gray-500">{{ invoicesData.name }}</span>
          </div>
          <div class="mb-4">
            <label class="block text-sm text-gray-700" for="firstName">
              {{lang['components']['Dialog']['PaymentInfoDialog']['payment_info_invoice_info_address_text']}}
            </label>
            <input
              class="w-full px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
              type="text"
              v-model="invoicesData.address"
              v-if="isEdit"
            />
            <span v-else class="text-gray-500">{{ invoicesData.address }}</span>
          </div>
          <div class="mb-4">
            <label class="block text-sm text-gray-700" for="firstName">
              {{lang['components']['Dialog']['PaymentInfoDialog']['payment_info_invoice_info_phone_text']}}
            </label>
            <input
              class="w-full px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
              type="text"
              v-model="invoicesData.mobile"
              v-if="isEdit"
            />
            <span v-else class="text-gray-500">{{ invoicesData.mobile }}</span>
          </div>
          <div class="mb-4">
            <label class="block text-sm text-gray-700" for="firstName">
              {{lang['components']['Dialog']['PaymentInfoDialog']['payment_info_invoice_info_email_text']}}
            </label>
            <input
              class="w-full px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
              type="text"
              v-model="invoicesData.email"
              v-if="isEdit"
            />
            <span v-else class="text-gray-500">{{ invoicesData.email }}</span>
          </div>
        </li>
      </ul>
      <form id="card_form" method="post" :action="formActive" target="card_form_open">
        <input type="hidden" name="CardID" :value="CardID">
        <input type="hidden" name="ClientRedirectURL" :value="ClientRedirectURL">
        <input type="hidden" name="MerchantID" :value="MerchantID">
        <input type="hidden" name="MerchantMemberID" :value="MerchantMemberID">
        <input type="hidden" name="MerchantTradeDate" :value="MerchantTradeDate">
        <input type="hidden" name="MerchantTradeNo" :value="MerchantTradeNo">
        <input type="hidden" name="ServerReplyURL" :value="ServerReplyURL">
        <input type="hidden" name="stage" :value="stage">
        <input type="hidden" name="TotalAmount" :value="TotalAmount">
        <input type="hidden" name="TradeDesc" :value="TradeDesc">
        <input type="hidden" name="CheckMacValue" :value="CheckMacValue">
      </form>
    <template #footer>
      <div class="w-full text-center py-4 border-gray-400">
        <button
          class="hover:bg-gray-200 focus:outline-none rounded-xl px-4 py-1 mx-auto text-gray-400 transition duration-500 ease-in-out mt-32 border-2"
          @click="showModal=false;isEdit=false;">{{lang['components']['Dialog']['PaymentInfoDialog']['payment_info_invoice_info_cancel_button_text']}}</button>
        <button
          class="bg-yellow-300 hover:bg-yellow-200 focus:outline-none rounded-xl px-4 py-1 mx-auto text-blue-800 transition duration-500 ease-in-out mt-32 border-2 border-yellow-400"
          @click="save_invoices()">{{lang['components']['Dialog']['PaymentInfoDialog']['payment_info_invoice_info_save_button_text']}}</button>
      </div>
    </template>
    <!-- <template #footer>
      <div class="w-full text-right py-4 border-t border-gray-400">
        <button
          class="hover:bg-gray-200 focus:outline-none rounded-xl px-4 py-1 mx-auto text-gray-400 transition duration-500 ease-in-out mt-32 border-2"
          @click="showModal=false">取消</button>
        <button
          class="bg-yellow-400 hover:bg-yellow-200 focus:outline-none rounded-xl px-4 py-1 mx-auto text-blue-800 transition duration-500 ease-in-out mt-32 border-2 border-yellow-400"
          @click="showModal=false">確認</button>
      </div>
    </template> -->
  </Dialog>
</template>

<script>
  import Dialog from 'primevue/dialog';
  import Swal from 'sweetalert2/dist/sweetalert2.js'
  import 'sweetalert2/dist/sweetalert2.min.css'
  import axios from 'axios'
  import Qs from 'qs'

  export default {
    name: 'PaymentInfoDialog',
    components: {
      Dialog
    },
    props: {
      show: {
        type: Boolean,
        default: false
      },
      invoices:{
        type:Object,
        required:true
      },
      memberId: {
        type: Number,
      },
      borderStyle: {
        type: Number,
      },
      info: {
        type: Object,
        default: () => ({
          taxId: 'taxId',
          name: 'name',
          address: 'address',
          phoneNumber: 'phoneNumber',
          email: 'email',
        })
      },
      lang: {
        type: Object
      },
    },
    data() {
      return {
        isEdit: false,
        formActive: null,
        CardID: null,
        ClientRedirectURL: null,
        MerchantID: null,
        MerchantMemberID: null,
        MerchantTradeDate: null,
        MerchantTradeNo: null,
        ServerReplyURL: null,
        stage: null,
        TotalAmount: null,
        TradeDesc: null,
        CheckMacValue: null,
      }
    },
    methods: {
      save_invoices(){
        // console.log('this.invoicesData');
        // console.log(this.invoicesData);

        let formData = this.invoicesData;

        axios
          .post('https://test.autoturn.net/inside/api/data/invoices_update.php', Qs.stringify({
            s_code: this.$route.params.id,
            form_data: formData,
            type: this.borderStyle
          }))
          .then((response) => {
            // if(response.data.status == 'success'){
              this.$swal(response.data.info);
              this.$emit('childIsPayEmptyInvoice', response.data.isPay_emptyInvoice);
              this.showModal = false;
              this.isEdit = false;
            // }
          });
      },
      payPlan(){
        axios
          .post('https://test.autoturn.net/inside/api/pay_card_update.php', Qs.stringify({
            s_code: this.$route.params.id
          }))
          .then((cuResponse) => {
            // console.log(cuResponse.data);
            if(cuResponse.data.status == 'success'){
              // this.$swal(response.data.info);
              // this.showModal = false;
              // this.isEdit = false;
              this.formActive = cuResponse.data.form_active;
              this.CardID = cuResponse.data.return_data.CardID;
              this.ClientRedirectURL = cuResponse.data.return_data.ClientRedirectURL;
              this.MerchantID = cuResponse.data.return_data.MerchantID;
              this.MerchantMemberID = cuResponse.data.return_data.MerchantMemberID;
              this.MerchantTradeDate = cuResponse.data.return_data.MerchantTradeDate;
              this.MerchantTradeNo = cuResponse.data.return_data.MerchantTradeNo;
              this.ServerReplyURL = cuResponse.data.return_data.ServerReplyURL;
              this.stage = cuResponse.data.return_data.stage;
              this.TotalAmount = cuResponse.data.return_data.TotalAmount;
              this.TradeDesc = cuResponse.data.return_data.TradeDesc;
              this.CheckMacValue = cuResponse.data.return_data.CheckMacValue;

              let TotalAmount_text = this.lang['components']['Dialog']['PaymentInfoDialog']['axios']['total_amount_default_text_a']+'<span style="color:red; font-weight:bold;">'+this.lang['components']['Dialog']['PaymentInfoDialog']['axios']['total_amount_default_text_b']+cuResponse.data.return_data.TotalAmount+this.lang['components']['Dialog']['PaymentInfoDialog']['axios']['total_amount_default_text_c']+'</span>'+this.lang['components']['Dialog']['PaymentInfoDialog']['axios']['total_amount_default_text_d'];

              if(cuResponse.data.return_data.TotalAmount > 5){
                  TotalAmount_text = '<span style="color:red; font-weight:bold;">'+this.lang['components']['Dialog']['PaymentInfoDialog']['axios']['total_amount_pay_again_text_a']+'</span>'+this.lang['components']['Dialog']['PaymentInfoDialog']['axios']['total_amount_pay_again_text_b'];
              }

              Swal.fire({
                title: this.lang['components']['Dialog']['PaymentInfoDialog']['axios']['swal_title'],
                html: TotalAmount_text,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: this.lang['components']['Dialog']['PaymentInfoDialog']['axios']['yes_button'],
                cancelButtonText: this.lang['components']['Dialog']['PaymentInfoDialog']['axios']['no_button'],
              }).then((result) => {
                if (result.isConfirmed) {
                  // console.log(this.$route.params.id);
                  // 開啟綠界刷卡小視窗
                  var iHeight = 700;
                  var iWidth = 1200;
                  //获得窗口的垂直位置
                  var iTop = (window.screen.availHeight - 30 - iHeight) / 2;
                  //获得窗口的水平位置
                  var iLeft = (window.screen.availWidth - 10 - iWidth) / 2;
                  var windowStyle = 'height=' + iHeight + ',innerHeight=' + iHeight + ',width=' + iWidth + ',innerWidth=' + iWidth + ',top=' + iTop + ',left=' + iLeft + ',status=no,toolbar=no,menubar=no,location=no,resizable=no,scrollbars=no,titlebar=no';

                  var newWindow = window.open('', 'card_form_open',windowStyle);
                  document.getElementById('card_form').submit();

                  let hash = this.$route.params.id;
                  let type = this.$route.params.type;

                  var timer = setInterval(function() {
                    console.log('newWindow:', newWindow);
                    // console.log(timer);
                    if(newWindow.closed) {
                      console.log('已關閉');
                      clearInterval(timer);
                      window.location.href = "https://dev-private.autoturn.net/"+type+'/'+hash;
                    }
                  }, 1000);
                }
              })
            }
          });

      }
    },
    computed: {
      showModal: {
        get: function () {
          return this.show
        },
        set: function (value) {
          this.$emit('update:show', value)
        }
      },
      infoData: {
        get: function () {
          return this.info
        },
        set: function (value) {
          this.$emit('update:infoData', value)
        }
      },
      invoicesData: {
        get: function () {
          return this.invoices
        },
        set: function (value) {
          this.$emit('update:invoicesData', value)
        }
      }
    }
  }
</script>

<style lang="scss" scope>

</style>